// Contact.js
import React, { useEffect } from "react";
import ContactHeader from "../components/Headers/ContactHeader.js";
import { Tabs } from "../components/Misc/Tabs.js";
import { ConsultationForm } from "../components/Forms/ConsultationForm.js";
import { VisitForm } from "../components/Forms/VisitForm.js";
import Seo from "../components/Misc/Seo";
import contactHeaderImage from "../assets/images/contact-header.jpg";

const API_BASE = process.env.REACT_APP_API_BASE || "https://studiosvc.norcat.org";

async function submitToBackend(submission) {
  const res = await fetch(`${API_BASE}/api/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(submission.toJSON()),
  });

  if (!res.ok) {
    let message = "Submission failed. Please try again.";
    try {
      const data = await res.json();
      if (data?.message) message = data.message;
    } catch {}
    throw new Error(message);
  }

  return res.json().catch(() => ({}));
}

function Contact() {
  const canonical = "https://studio.norcat.org/Contact";
  const title = "Contact Studio NORCAT | A Studio driven by experiences that matter.";
  const description =
    "Get in touch with Studio NORCAT to explore ideas, discuss projects, or connect about immersive training, software, simulation, and interactive experiences.";

  useEffect(() => {
    document.body.classList.add("contact-page-view");

    return () => {
      document.body.classList.remove("contact-page-view");
    };
  }, []);

  const onSubmitData = (submission) => submitToBackend(submission);

  return (
    <>
      <Seo
        title={title}
        description={description}
        canonical={canonical}
        ogTitle={title}
        ogDescription={description}
        ogImage={`${window.location.origin}${contactHeaderImage}`}
        ogImageAlt="A view of the Studio NORCAT lobby"
        twitterTitle={title}
        twitterDescription={description}
        twitterImage={`${window.location.origin}${contactHeaderImage}`}
        twitterImageAlt="A view of the Studio NORCAT lobby"
      />
      <ContactHeader />
      <div className="contact-section">
        <div className="contact-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="contact-form-wrapper">
                  <Tabs
                    labelListClass={"contact-form-tab"}
                    tabs={[
                      {
                        id: "tab-1",
                        tabLabel: "Explore an Idea",
                        content: <ConsultationForm onSubmitData={onSubmitData} />,
                      },
                      {
                        id: "tab-2",
                        tabLabel: "Say Hello",
                        content: <VisitForm onSubmitData={onSubmitData} />,
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
